<template>
    <TeamMember />
</template>
<script>
import TeamMember from '../backend/components/TeamMember/index.vue'
import $ from "jquery";
export default {
    name: 'TeamMemberPage',
    components: {
        TeamMember,
    },
    data() {
        return {
            windowWidth: window.innerWidth,
        }
    },
    async mounted() { 
        this.$store.state.isAdmin = 2
        this.$store.state.pageTitle = 'Team Member'
        if(this.windowWidth < 991){
            $('.mainbody_cssclass').removeClass('sideMenuActive');
        }
    },
}
</script>